<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class="h100vh-100 h-scroll">
        <TaskTable ref='taskTable'></TaskTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TaskTable from '../../components/tsConfig/Task/TaskTable';


export default {
  name: 'TrafficTaskPage',
  components: {
    BasicLayout,
    TaskTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.trafficTaskManagement')}`
      }
    };
  }
};
</script>

<style scoped>

</style>
